var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-wrapper"},[_c('Calendar',{attrs:{"first-instance":_vm.firstInstance,"last-instance":_vm.lastInstance,"available-months":JSON.parse(_vm.availableMonths)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }